
import { BlogSection } from '@/types/blog';

export const unbewusstGesteuertSection: BlogSection = {
  id: 'unbewusst-gesteuert',
  title: 'Warum unser Verhältnis zu Geld oft unbewusst gesteuert wird',
  content: `
    <p>
      Geld ist in unserem Gehirn eng mit Emotionen verknüpft. Laut Studien aus der Neuroökonomie werden finanzielle 
      Entscheidungen nicht primär in den rationalen Arealen unseres Gehirns getroffen, sondern im limbischen System – 
      dem Zentrum für Emotionen und Belohnungsverarbeitung (Knutson & Kuhnen, 2005).
    </p>
    
    <h3>Belohnung & Impulskäufe</h3>
    
    <p>
      Das Gehirn reagiert auf Geld ähnlich wie auf Schokolade oder soziale Anerkennung – es aktiviert das 
      Dopamin-Belohnungssystem (Rick et al., 2008). Das führt dazu, dass kurzfristige Konsumfreuden oft stärker 
      wirken als langfristige finanzielle Ziele.
    </p>
    
    <h3>Angst & Geldblockaden</h3>
    
    <p>
      Geld kann auch Stress auslösen. Forscher der Yale University fanden heraus, dass finanzielle Unsicherheit 
      ähnliche neuronale Muster erzeugt wie physische Bedrohung (Shafir et al., 2013). Unser Gehirn reagiert mit 
      Flucht- oder Vermeidungsverhalten – wir schieben Geldthemen vor uns her oder vermeiden Investitionen aus 
      Angst vor Verlusten.
    </p>
    
    <h3>Finanzielle Gewohnheiten</h3>
    
    <p>
      Wiederholte Geldentscheidungen prägen neuronale Verbindungen im Gehirn. Wer regelmäßig impulsiv kauft oder 
      Geld vermeidet, programmiert sein Gehirn darauf – aber diese Muster lassen sich umtrainieren 
      (Loewenstein et al., 2001).
    </p>
  `
};
